import { v4 as uuidv4 } from 'uuid';

export const getDeviceId = () => {
    let deviceId = localStorage.getItem('device_id');
    if (!deviceId) {
        deviceId = uuidv4();
        localStorage.setItem('device_id', deviceId);
    }
    return deviceId;
};

export const getDeviceInfo = () => {
    const ua = navigator.userAgent;

    // Device Type
    let deviceType = "Unknown";
    if (/mobile/i.test(ua)) {
        deviceType = "Mobile";
    } else if (/tablet/i.test(ua)) {
        deviceType = "Tablet";
    } else {
        deviceType = "Desktop";
    }

    // Browser Detection
    let browser = "Unknown Browser";
    let browserVersion = "";
    if (/chrome|crios|crmo/i.test(ua)) {
        browser = "Chrome";
        browserVersion = ua.match(/(?:chrome|crios)\/([\d.]+)/i)?.[1] || "";
    } else if (/firefox|fxios/i.test(ua)) {
        browser = "Firefox";
        browserVersion = ua.match(/firefox\/([\d.]+)/i)?.[1] || "";
    } else if (/safari/i.test(ua) && !/chrome|crios|crmo/i.test(ua)) {
        browser = "Safari";
        browserVersion = ua.match(/version\/([\d.]+)/i)?.[1] || "";
    } else if (/edg/i.test(ua)) {
        browser = "Edge";
        browserVersion = ua.match(/edg\/([\d.]+)/i)?.[1] || "";
    }

    // OS Detection
    let os = "Unknown OS";
    if (/Windows NT 11.0/i.test(ua)) os = "Windows 11";
    else if (/Windows NT 10.0/i.test(ua)) os = "Windows 10";
    else if (/Windows NT 6.1/i.test(ua)) os = "Windows 7";
    else if (/Mac OS X (\d+[_\.]\d+)/i.test(ua))
        os = `macOS ${ua.match(/Mac OS X (\d+[_\.]\d+)/i)?.[1].replace(/_/g, ".")}`;
    else if (/Android (\d+[\.\d]*)/i.test(ua))
        os = `Android ${ua.match(/Android (\d+[\.\d]*)/i)?.[1]}`;
    else if (/iPhone OS (\d+[_\d]*)/i.test(ua))
        os = `iOS ${ua.match(/iPhone OS (\d+[_\d]*)/i)?.[1].replace(/_/g, ".")}`;

    const userAgent = `${browser} ${browserVersion} on ${os}`;
    const deviceName = `${deviceType} ${userAgent}`;

    return { deviceType, userAgent, deviceName };
};

export const getIpAddress = async () => {
    let ip = sessionStorage.getItem("ip");
    if (ip) return ip;

    try {
        const res = await fetch("https://api.ipify.org?format=json");
        const data = await res.json();
        sessionStorage.setItem("ip", data.ip);
        return data.ip;
    } catch {
        return "0.0.0.0";
    }
};

// Combined export
export const getFullDeviceInfo = async () => {
    return {
        deviceId: getDeviceId(),
        ...getDeviceInfo(),
        ipAddress: await getIpAddress(),
    };
};
